module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/57a47b7ba3befc2a2e324716b85048b8.png";